import { Input } from "@angular/core";

export const zapisnik_pokretnine= {
    templateId: 83,
    category: 8,
    templateTitle: 'Zapisnik pri predaji pokretnina',
    templateDescription: `<p>Uporabom stvari može doći do promjene kvalitete, a time i sporova o tome tko je uzrokovao promjenu kvalitete, stoga se preporuča kod predaje i povrata potpisati zapisnik kojim se utvrđuje stanje stvari i eventualni nedostaci.</p>`,
    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Zapisnik o predaji pokretnine predstavlja dobru praksu u poslovanju te je vrlo važan odnosno ponekad nužan radi predočenja u slučaju bilo kakvog spora oko utvrđivanja promjena kvalitete predane stvari odnosno utvrđivanja odgovornosti jedne od ugovornih strana za promjenu kvalitete predane stvari.</p>
    <p>Osim toga, potpisani zapisnik predstavlja dokaz o izvršenoj predaji te dokaz da je predaja pokretnine obavljena na određeni dan.</p>
    <p>U praksi se često događa da ugovorne strane pri primopredaji stvari ne potpišu zapisnik u kojemu se utvrđuje stanje stvari kod predaje i datum predaje.</p> 
    <p>Takvo postupanje znatno otežava jednostavan način utvrđivanja ugovorne strane koja je odgovorna za eventualno smanjenje kvalitete stvari odnosno točnog datuma predaje stvari, što može dovesti do sporova u kojima bi se utvrđivala odgovornost pojedine ugovorne strane.</p> 
    <p>Dakle, kreiranje i potpisivanje zapisnika o predaji (i povratu) pokretnine stvara pravnu sigurnost za obje ugovorne strane.</p>

    `,
    
    sides: [
        {
            signature: 'Za Predavatelja:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
          ],
            suffix: ' (u daljnjem tekstu: Predavatelj)',
            delimiter: `i`
        },
        {
            signature: 'Za Preuzimatelja:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
        ],
            suffix: ' (u daljnjem tekstu: Preuzimatelj),'
        }
    ],

    headline: "potpisuju sljedeći",
    title: 'ZAPISNIK PRI PREDAJI POKRETNINA',
    noArticleNumbers: true,
    noArticleTitle: true,

    articles: [

      {
        title: '',
        mandatory: true,
        dummy: true,
        statements: [
        
          {
            type: "input",
            editable: false,
            mandatory: true,
            parts: [
          
              {type: "text", content: "Ovim Zapisnikom Predavatelj vrši predaju pokretnine/a Preuzimatelju i to: "},
              { type: "textarea", newline:"true", content: "", required: true,  help: 'Ovdje unosite podatke o pokretnini/pokretninama, npr. za vozila i strojeve sve podatke koje imate, proizvođač, broj stroja/broj šasije, model/tip, godina proizvodnje, inventurni broj i sl.',  },
              { type: "text",  content: "\r\n\r\nPrethodno opisano dalje u tekstu se navodi kao Predmet primopredaje.",},
            ],
  
            }
          ]
        }, 
        {
          title: '',
          mandatory: false,
          dummy: true,
          statements: [
          
            {
              type: "input",
              editable: false,
              mandatory: true,
              parts: [
            
                {type: "text", content: "Primopredaja se obavlja u sljedeću svrhu:"},
                { type: "textarea", newline:"true", content: "", required: true,  help: 'Ovdje upisujete naziv ugovora ili pravne osnove na temelju koje se obavlja predaja.',  },
              ],
    
              }
            ]
          },
        {
          title: "",
          mandatory: true,
          dummy: true,
          statements: [
            {
              type: "input",
              mandatory: true,
              parts: [
                { type: "text", content: "Za Predavatelja prisutan:" },
                { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                { type: "text", content: "," },
                { type: 'text', content: 'iz',},
                { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                { type: 'text', content: ',' },
                { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                { type: "text", content: "," },
                { type: 'text', content: 'OIB:' },
                { type: "input",  required: true,},
                { type: "text", content: "." }, 
                { help: "Ovdje upisujete podatke osobe koja je u ime Predavatelja prisutna prilikom primopredaje."},
              ],
          },
          ]
        },
        {
          title: "",
          mandatory: true,
          dummy: true,
          statements: [
       
          {
              type: 'input',
              mandatory: true,
              editable: false,
              dummy: true,
              parts: [    
                { type: "text", content: "Za Preuzimatelja prisutan:" },
                { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                { type: "text", content: "," },
                { type: 'text', content: 'iz',},
                { type: 'input', value: '', required: true, placeholder: "Mjesto"  },
                { type: 'text', content: ',' },
                { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                { type: "text", content: "," },
                { type: 'text', content: 'OIB:' },
                { type: "input",  required: true,},
                { type: "text", content: "." },   
                { help: "Ovdje upisujete podatke osobe koja je u ime Preuzimatelja prisutna prilikom primopredaje."},
              ],
            }
          ]
        },
          {
            title: "",
            mandatory: true,
            dummy: true,
            type: "input",
            statements: [
              {
                type: "choice",
                mandatory: true,
                editable: false,
                choices: [
                    {
                        parts: [
                          { type: "text", content: "Potpisnici ovog Zapisnika konstatiraju da u trenutku primopredaje ne postoje nedostaci Predmeta primopredaje. " },
                        ]
                      },
                {
                    parts: [

                        { type: "text", content: "Potpisnici ovog Zapisnika konstatiraju da u trenutku primopredaje postoje sljedeći nedostaci Predmeta primopredaje: " },
                        { type: "textarea", value: "", required: true },
                    ]
                  },
                ],
              }
            ]
          },
        {
            title: '',
            mandatory: false,
            dummy: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Kao vlastoručni potpisnici gore prikazanih podataka izjavljujemo da su navedeni podaci potpuni, istiniti i točni.',
                    value: '',
                },
            ],
            value: '',
        }, 
        {
            title: '',
            mandatory: false,
            dummy: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {
                            type: 'text',
                            content: 'Primopredaja je izvršena u'
                        },
                        {
                            type: 'input',
                            value: '',
                            placeholder: "Upišite mjesto.",
                            required: true
                        },
                        {
                            type: 'text',
                            content: ', dana'
                        },
                        {
                          type: 'input',
                          value: '',
                          placeholder: "Upišite datum.",
                          required: true
                      },
                        {
                            type: 'text',
                            content: 'godine.'
                        }
                    ]
                },
            ]
        },
    
        {
          title: '',
          mandatory: false,
          dummy: true,
          statements: [
              {
                  type: 'text',
                  required: false,
                  mandatory: true,
                  editable: true,
                  content: 'Ovaj Zapisnik sastavljen je u 2 (dva) primjerka, od kojih svaka strana zadržava po 1 (jedan) primjerak.',
                  value: '',
              }],
        },
                {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
            ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/83_zapisnik_pokretnine.ts